import React from 'react';
import { AppRemixIcon } from '@/layout/AppComponents';

export default function AdvancedSearchResultType0({ data }) {
  return (
    <table className="table table-striped table-hover table-sm">
      <thead>
        <tr>
          <th className="col-lg-1">Origen</th>
          <th className="col-lg-1">Fecha</th>
          <th className="col-lg-1">Organismo emisor</th>
          <th className="col-lg-1">Nombre proyecto</th>
          <th className="col-lg-1">Tecnología</th>
          <th className="col-lg-1">Potencia (MW)</th>
          <th className="col-lg-1">Promotor/Solicitante</th>
          <th className="col-lg-2">Localidad</th>
          <th className="col-lg-1">Provincia</th>
          <th className="col-lg-1">Comunidad Autónoma</th>
          <th className="col-lg-2">Alegaciones</th>
          <th className="col-lg-3">Grupos alegantes</th>
          <th className="col-lg-2">Tipo de entidad</th>
          <th className="col-lg-2">Temática de las alegaciones</th>
          <th className="col-lg-1">Sentido DIA</th>
          <th className="col-lg-1">Enlace</th>
        </tr>
      </thead>
      <tbody>
        {data?.map((d, i) => (
          <tr key={i}>
            <td>{d.source}</td>
            <td>{d.date}</td>
            <td>{d.data.organism}</td>
            <td>{d.data.projectName}</td>
            <td>{d.data.tecnology}</td>
            <td>{d.data.power}</td>
            <td>{d.data.promotor}</td>
            <td>{d.data.city}</td>
            <td>{d.data.province}</td>
            <td>{d.data.community}</td>
            <td>{d.data.alegations}</td>
            <td>{d.data.alegationGroups}</td>
            <td>{d.data.entityType}</td>
            <td>{d.data.alegationTheme}</td>
            <td>{d.data.dia}</td>
            <td>
              <a href={d.url} target="_blank" rel="noopener noreferrer">
                <AppRemixIcon icon="external-link" />
              </a>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
